module.exports = __webpack_public_path__ + "media/components/country-flag/static/tj-71c18cc6c6e3f4a4df3bcd3e1fd4c8a1.svg";